module.exports = __webpack_public_path__ + "static/media/tuteby-logo.34af7564.svg";